var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',_vm._b({attrs:{"number-to-display":1,"heading":"Contacts","hide-default-bg-image":"","tables":[_vm.report.contactsTableImageId, _vm.report.repsTableImageId]}},'page',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }